import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Heading, Stack, Image, Box, Grid } from '@eneco/sparky';
import { ImageProps } from '@eneco/sparky/types';

export type MeterArticleProps = {
  title?: string;
  meterImage: ImageProps;
  counterImage: ImageProps;
  description: string;
};

export const MeterArticle: FC<MeterArticleProps> = ({ title, meterImage, counterImage, description }) => (
  <Stack gap="3">
    {title && (
      <Heading as="h3" size="3XS">
        {title}
      </Heading>
    )}
    <Grid gridTemplateColumns={{ initial: '1fr', md: '1fr 1fr' }}>
      <Box backgroundColor={'backgroundSecondary'} paddingY="6">
        <Stack alignX="center" alignY="center">
          <Image {...meterImage} maxWidth="100%" />
        </Stack>
      </Box>
      <Stack alignX="center" alignY="center">
        <Image {...counterImage} maxWidth="100%" />
      </Stack>
    </Grid>
    <RichText html={description} />
  </Stack>
);
